module.exports = __webpack_public_path__ + "static/media/slider-img3.334aaf2a.png";